import { Card, CardContent } from "@/components/ui/card";
import {
  PenLine,
  ListChecks,
  FileSignature,
  ArrowRight,
} from "lucide-react";

const STEPS = [
  {
    icon: PenLine,
    title: "Tell us about you",
    body: "8 guided steps — personal details, family, assets, beneficiaries, executor, optional guardian for minors.",
  },
  {
    icon: ListChecks,
    title: "We assemble your will",
    body: "Our guided legal will builder prepares a professionally formatted will in seconds, structured under Indian succession principles.",
  },
  {
    icon: FileSignature,
    title: "Download. Sign. Done.",
    body: "Complete a secure payment, download your polished PDF or DOCX, and sign in the presence of two witnesses — your will is legally valid.",
  },
];

export default function HowItWorks() {
  return (
    <section
      className="relative overflow-hidden bg-white py-20 sm:py-24"
      data-testid="how-it-works-section"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            How It Works
          </div>
          <h2 className="mt-3 font-serif text-3xl text-navy sm:text-4xl">
            Three steps. Ten minutes. Lifetime protection.
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-[#4A5568] sm:text-base">
            We turned the most stressful legal task in India into the simplest 10-minute
            errand on your to-do list.
          </p>
        </div>

        <div className="relative mt-12 grid gap-5 md:grid-cols-3">
          {/* gold connector line */}
          <div className="pointer-events-none absolute left-0 right-0 top-12 hidden h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent md:block" />

          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Card
                key={i}
                className="hover-lift relative border-[#0A1128]/10 bg-white shadow-sm"
                data-testid={`how-step-${i}`}
              >
                <CardContent className="relative p-8">
                  <div className="flex items-center gap-3">
                    <div className="relative flex h-12 w-12 items-center justify-center rounded-md bg-navy text-gold">
                      <Icon size={20} />
                    </div>
                    <span className="font-serif text-3xl text-gold/70">{`0${i + 1}`}</span>
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-navy">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#4A5568]">{s.body}</p>
                  {i < STEPS.length - 1 && (
                    <ArrowRight
                      size={20}
                      className="absolute -right-3 top-1/2 hidden -translate-y-1/2 rounded-full border border-gold/30 bg-white p-1 text-gold md:block"
                    />
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
